import { Component, Input } from '@angular/core';
import { Negotiation, NegotiationEvent, User } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-mmao-history',
  templateUrl: './mmao-history.component.html',
  styleUrls: ['./mmao-history.component.scss']
})
export class MmaoHistoryComponent {
  @Input()
  negotiation: Negotiation;

  getRequester(event: NegotiationEvent): User {
    if (event.createdBy === 'buyer') {
      return this.negotiation.buyer;
    }
    if (event.createdBy === 'seller') {
      return this.negotiation.seller;
    }

    return null;
  }
}
